import { i18n } from 'localization'

export default class Options {
	static fromJSON(json) {
		if (Array.isArray(json)) {
			return json.map(({ value, text }) => ({
				value: value.toString(),
				valueString: i18n.translate(value),
				text: i18n.translate(text),
			}))
		} else if (json) {
			return {
				value: json.value,
				valueString: i18n.translate(json.value),
				text: i18n.translate(json.text),
			}
		}
	}
	static fromSimpleObjectJSON(json) {
		return {
			value: json.id?.toString(),
			text: i18n.translate(json.name),
		}
	}
	static fromSimpleObjectIdAsNumberJSON(json) {
		return {
			value: parseInt(json.id?.toString()),
			text: i18n.translate(json.name),
		}
	}
	static fromMedicalDiagnosis(json) {
		try {
			const result = json
				? [
						json.mainMedicalDiagnosis,
						...(json.medicalDiagnosis || []),
				  ].map((json) => ({
						value: json.icd9Code,
						text: json.icd9Diagnostic,
				  }))
				: []
			return result
		} catch (e) {
			return []
		}
	}
}
